import { useState, useEffect } from 'react';

const FormElementsEditor = (props) => {
	const [dynamic, setDynamic] = useState(null);

	useEffect(() => {
		const loadDynamic = async () => {
			const x = await import('./FormElementsEditor');
			setDynamic(() => x.default);
		};
		loadDynamic();
	}, []);

	if (!dynamic) {
		return <div>Loading...</div>;
	}
	const Component = dynamic;
	return <Component {...props} />;
};

export default FormElementsEditor;
